export const ROW_SM = 88;

export const ROW_LG = 108;

export const ROWS_GAP_SM = 8;

export const ROWS_GAP_LG = 12;

export const COL_WIDTH = 100;
